// icon boton
import { Button, IconButton, Tooltip } from '@mui/material';

export default function GButton({
  children,
  onClick,
  tooltip,
  disabled = false,
  color = 'inherit',
  sx = {}
}) {

  return (
    <Tooltip title={tooltip}
      slotProps={{
        tooltip: {
          sx: {
            fontSize: '12px'
          }
        }
      }}
    >
      <span>
        <IconButton
          color={color}
          onClick={onClick}
          disabled={disabled}
          sx={sx}
        >
          {children}
        </IconButton>
      </span>
    </Tooltip>
  );
}